module.exports = __webpack_public_path__ + "img/37_69.82104538.png";